import { readItemFieldReference, readInventoryTemplateId } from '../compile/item-field-reader.js';

type Row = Record<string, unknown>;
const upper = (value: unknown): string => String(value ?? '').trim().toUpperCase();

/** A GM status UUID is provenance only; it never names a second definition payload.
 * Callers supply their existing readers' scalar values (including lean omissions).
 */
export function isSelfStatusOrigin(statusId: unknown, originId: unknown): boolean {
  return typeof statusId === 'string' && statusId !== '' && statusId === originId;
}
/** Origins retain their physical identity for connections. Rule inputs use the
 * definition carried by the saved snapshot, including gear no longer held here.
 * An incomplete inventory snapshot never becomes an inventory-entity fetch.
 */
export function statusOriginDefinitionId(status: Row, heldOrigin?: Row): string {
  const origin = upper(readItemFieldReference(status, 'status_origin_id'));
  if (isSelfStatusOrigin(upper(readItemFieldReference(status, 'status_id')), origin)) return '';
  const value = readItemFieldReference(status, 'status_origin_arr');
  const snapshot = value && typeof value === 'object' && !Array.isArray(value) ? value as Row : heldOrigin;
  if (snapshot?.inventory) return upper(readInventoryTemplateId(snapshot));
  return (snapshot ? upper(readItemFieldReference(snapshot, 'item_id')) : typeof value === 'string' ? upper(value) : '') || origin;
}
